import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

export function waitForTranslationLoaded(translate: TranslateService): Observable<true> {
    return translate.stream('settings.title');
}
